import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateTrendingSearchEntity } from '../../domain/entities/CreateUpdateTrendingSearchEntity'

export class CreateUpdateTrendingSearchModel extends CreateUpdateTrendingSearchEntity {
  channelId?: number
  constructor(dataDto: CreateUpdateTrendingSearchEntity) {
    super()
    mapEntityProperties<CreateUpdateTrendingSearchModel>(this, dataDto, {
      exclude: ['channel'],
      map: {
        channelId: dataDto.channel?.id
      }
    })
  }
}
